export default __webpack_public_path__ + "static/media/154.ed6238fa.jpg";